export { default } from "./Customers";
